const resetInputFileValue = (event) => {
    event.target.value = null;
}

export default resetInputFileValue;